<script lang="ts">
import type { ICellRendererParams } from 'ag-grid-community';
import { defineComponent, ref, type PropType } from 'vue';
import { vOnClickOutside } from '@vueuse/components';
import TreeNodeSelectList from '@/components/common/TreeNodeSelectList.vue';
import type { TreeBase } from '@/composables/useTreeNode';
import { useI18n } from 'vue-i18n';

type ExtendedParams = ICellRendererParams<any, void> & {
    selectedValue: string | null;
    options: TreeBase[];
    deselectOptionTitle?: string;
};

export default defineComponent({
    components: { TreeNodeSelectList },
    directives: {
        onClickOutside: vOnClickOutside
    },
    props: {
        params: {
            type: Object as PropType<ExtendedParams>,
            required: true
        }
    },
    setup(props) {
        const { t } = useI18n();

        const selectedValue = ref<string | null>(props.params.selectedValue);

        function changeNode(changedNodes: (TreeBase | null)[], _newSelectedState: string[]): void {
            selectedValue.value = changedNodes[0]?.id ?? null;
            props.params.api.stopEditing();
        }

        function closePopup(): void {
            props.params.api.stopEditing();
        }

        function getValue(): string | null {
            return selectedValue.value;
        }

        return {
            t,
            changeNode,
            closePopup,
            getValue
        };
    }
});
</script>

<template>
    <div v-on-click-outside="closePopup">
        <TreeNodeSelectList
            class="dropdown-menu"
            :options="params.options"
            :selected-values="params.selectedValue != null ? [params.selectedValue] : []"
            :settings="{
                showDeselectOption: params.selectedValue != null,
                deselectOptionTitle: params.deselectOptionTitle ?? t('components.treeNodeSelect.selectOption')
            }"
            @change="changeNode"
        />
    </div>
</template>
